<script setup lang="ts">
import { RouterLink } from 'vue-router'
import { useInstallNudge } from '@/composables/useInstallNudge'

// Diskret toast over tabbaren (samme kropssprog som DiscoveryToast). Chrome/Android faar
// den native prompt; iOS faar vejen til anvisningen paa /about — dér findes ingen prompt.
const { visible, installable, dismiss, install } = useInstallNudge()
</script>

<template>
  <transition name="nudge">
    <div v-if="visible" class="nudge" role="status">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M12 3v12" /><path d="m7 10 5 5 5-5" /><path d="M5 21h14" />
      </svg>
      <div class="nudge-text">
        <strong>{{ $t('installNudge.title') }}</strong>
        <button v-if="installable" type="button" class="nudge-action" @click="install">
          {{ $t('installNudge.install') }}
        </button>
        <RouterLink v-else class="nudge-action" to="/about#installer" @click="dismiss">
          {{ $t('installNudge.how') }}
        </RouterLink>
      </div>
      <button type="button" class="nudge-close" :aria-label="$t('installNudge.dismiss')" @click="dismiss">✕</button>
    </div>
  </transition>
</template>

<style scoped>
.nudge {
  position: fixed;
  left: 50%;
  bottom: calc(env(safe-area-inset-bottom, 0px) + 5.5rem);
  transform: translateX(-50%);
  z-index: 70;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  max-width: min(22rem, calc(100vw - 2rem));
  padding: 0.75rem 1.1rem;
  border: 1px solid color-mix(in srgb, var(--accent) 40%, transparent);
  border-radius: 999px;
  background: var(--surface-solid, var(--surface));
  box-shadow: var(--shadow);
}
.nudge svg { width: 1.6rem; height: 1.6rem; flex: none; color: var(--accent); }
.nudge-text strong { display: block; font-family: var(--font-display); font-size: 0.92rem; }
.nudge-action {
  background: none; border: 0; padding: 0; margin: 0.1rem 0 0;
  font: inherit; font-size: 0.85rem; font-weight: 600; color: var(--accent);
  text-decoration: none; cursor: pointer; display: inline-block;
}
.nudge-action:hover { text-decoration: underline; text-underline-offset: 3px; }
.nudge-close {
  background: none; border: 0; padding: 0.25rem; margin: 0;
  color: var(--muted); font-size: 0.9rem; cursor: pointer; flex: none;
}
.nudge-close:hover { color: var(--text); }

.nudge-enter-active, .nudge-leave-active { transition: opacity 0.35s, transform 0.35s; }
.nudge-enter-from, .nudge-leave-to { opacity: 0; transform: translate(-50%, 0.75rem); }
</style>
